export const SET_USER = 'SET_USER';
export const UPDATE_USER_TOKEN = 'UPDATE_USER_TOKEN';
export const SHOW_LOGIN = 'SHOW_LOGIN';
export const HIDE_LOGIN = 'HIDE_LOGIN';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const SET_REGISTER_VISIBILITY = 'SET_REGISTER_VISIBILITY';
export const SET_FORGOT_PASSWORD_VISIBILITY = 'SET_FORGOT_PASSWORD_VISIBILITY';
export const SET_USER_MENU_VISIBILITY = 'SET_USER_MENU_VISIBILITY';
